import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid} from '@mui/material';

import {Loading} from '../../../components/Loading/Loading';
import {SnackBarContext} from '../../../contexts/SnackBarContext/SnackBarContext';
import {ApplicantProfilePageHeader} from '../../../features/applicant/profile/components/ApplicantProfilePageHeader';
import {ProfileForm} from '../../../features/applicant/profile/components/ProfileForm';
import {useApplicantProfile} from '../../../features/applicant/profile/hooks/useApplicantProfile';
import {useApplicantSkills} from '../../../features/applicant/profile/hooks/useApplicantSkills';
import {ApiResponseError} from '../../../lib/api/v1/types';

export const ApplicantProfilePage = () => {
  const {t} = useTranslation();
  const {dispatchMessage} = useContext(SnackBarContext);

  const {profile, updateProfile, refreshProfile, isLoading: isProfileLoading} = useApplicantProfile();

  const onProfileUpdateSuccess = () => {
    dispatchMessage(t('shared.formSubmit.success'), 'success');
  };

  const onProfileUpdateError = (error?: ApiResponseError) => {
    if (error) {
      dispatchMessage(t('shared.formSubmit.error', error), 'error');
    }
  };

  const onSkillUpdateSuccess = () => {
    onProfileUpdateSuccess();
  };

  const onSkillUpdateError = () => {
    dispatchMessage(t('shared.formSubmit.error'), 'error');
  };

  const {applicantSkills, isLoading: isSkillsLoading, createApplicantSkills} = useApplicantSkills({
    onUpdateSuccess: onSkillUpdateSuccess,
    onUpdateError: onSkillUpdateError,
  });

  if (isProfileLoading || isSkillsLoading || !profile) {
    return <Loading backDrop />;
  }

  return (
    <Grid container width='100%'>
      <Box component='main' sx={{flexGrow: 1}}>
        <ApplicantProfilePageHeader />
        <Grid width='100%'>
          <ProfileForm
            applicantSkills={applicantSkills || []}
            createApplicantSkills={createApplicantSkills}
            profile={profile}
            onRefetchProfile={refreshProfile}
            onUpdateProfile={updateProfile}
            onSaveSuccess={onProfileUpdateSuccess}
            onSaveError={onProfileUpdateError}
          />
        </Grid>
      </Box>
    </Grid>
  );
};

export default ApplicantProfilePage;
